import {
  fetchV1Customers,
  createV1Customer,
  getOrCreateV1Customer,
} from "@/services/v1/crmAPIService";

export default {
  state: {
    customer: null,
    customers: [],
    customerPageSize: 5,
    totalCustomerCount: 0,
  },
  getters: {
    customer: (state) => state.customer,
    customers: (state) => state.customers,
    currentCustomerPageSize: (state) => state.customerPageSize,
    totalCustomerCount: (state) => state.totalCustomerCount,
  },
  mutations: {
    SET_CUSTOMER(state, customer) {
      state.customer = customer;
    },
    SET_CUSTOMERS(state, customers) {
      state.customers = customers;
    },
    SET_CUSTOMER_PAGE_SIZE(state, pageSize) {
      state.customerPageSize = pageSize;
    },
    SET_TOTAL_CUSTOMER_COUNT(state, count) {
      state.totalCustomerCount = count;
    },
  },
  actions: {
    async fetchCustomers({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Customers(page, pageSize);
        commit("SET_CUSTOMERS", response.results);
        commit("SET_CUSTOMER_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_CUSTOMER_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async addCustomer({ commit }, customer) {
      try {
        const response = await createV1Customer(customer);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`customer create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add customer.";
        return { success: false, message };
      }
    },
    async getOrCreateCustomer({ commit }, customer) {
      try {
        const response = await getOrCreateV1Customer(customer);
        commit("SET_CUSTOMER", response);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`customer create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add customer.";
        return { success: false, message };
      }
    },
  },
};
